import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { useElementSize } from "@geome/react-next/lib/hooks/useElementSize";
import { useI18n } from "@geome/react-next/lib/hooks/i18n";
import { useStaticMapUrl } from "./hooks/useStaticMapUrl";
import { GeomeLogoLink } from "../geomeLogoLink";
const MAX_STATIC_IMAGE_WIDTH = 640;
export const StaticMap = ({ static_map_url, locationId, locale = "en_GB", locationName = "", roundDownToNearest, configPath, sectionName, showLogo = false, mode = "light", }) => {
    const [size, imageRef] = useElementSize();
    const { translate } = useI18n();
    const { width, height } = useMemo(() => {
        if (!size)
            return { width: null, height: null };
        // Assumes that width will always be greater than height
        const scalingFactor = Math.min(1, MAX_STATIC_IMAGE_WIDTH / size.width);
        let width = Math.round(size.width * scalingFactor);
        let height = Math.round(size.height * scalingFactor);
        if (roundDownToNearest) {
            const ratio = height / width;
            width = Math.floor(width / roundDownToNearest) * roundDownToNearest;
            height = Math.round(width * ratio);
        }
        return { width, height };
    }, [size, roundDownToNearest]);
    const imageUrl = useStaticMapUrl({
        template: static_map_url,
        locale,
        id: locationId,
        width,
        height,
        mode,
    });
    // Fixes issue where maps load with NaN height in some context
    if (!width || !height)
        return _jsx("div", { className: "static-map", ref: imageRef });
    return (_jsxs("div", { className: "static-map", ref: imageRef, children: [imageUrl && (_jsx("img", { className: "static-map__image", src: imageUrl, alt: translate(`${configPath}sections.${sectionName}.alt_text`, { locationName }) })), showLogo && _jsx(GeomeLogoLink, { className: "static-map__our-logo" })] }));
};
